import { defineAsyncComponent } from 'vue'
export default {
  chat: defineAsyncComponent(() => import("/builds/magyar-telekom/ida-comind-ui/layouts/chat.vue").then(m => m.default || m)),
  default: defineAsyncComponent(() => import("/builds/magyar-telekom/ida-comind-ui/layouts/default.vue").then(m => m.default || m))
}